export const CHAT_REQUEST = "CHAT_REQUEST"
export const CHAT_SUCCESS = "CHAT_SUCCESS"
export const CHAT_FAIL = "CHAT_FAIL"
export const CHAT_RESET = "CHAT_RESET"